module.exports = __webpack_public_path__ + "static/img/s8.4529a5d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CorporateTravel/s8.png
// module id = APLV
// module chunks = 1